<template>
  <div v-loading="loading">
    <div style="display: flex; justify-content: flex-end">
      <div style="margin: 10px">
        <b>Leltártöbblet:</b> {{ plusStock | currency }}
      </div>
      <div style="margin: 10px">
        <b>Leltárhiány:</b> {{ minusStock | currency }}
      </div>
      <div style="margin: 10px">
        <b>Összesen:</b> {{ plusStock + minusStock | currency }}
      </div>
    </div>
    <div class="" style="float: right; margin-bottom: 15px;" v-if="isEstimated">
      <el-alert
        title="A számított többlet és hiány becsült érték, mert a listában van becsült árú termék!"
        type="warning"
        :closable="false">
      </el-alert>
    </div>

    <el-table
      :data="stockDifference"
      style="width: 100%"
      row-key="id"
      border
    >
      <el-table-column
          prop="count"
          label="Termék"
      >
        <template slot-scope="scope">
          {{  scope.row.product_name }}
        </template>
      </el-table-column>
      <el-table-column
          prop="created_at"
          label="Dátum"
          width="110"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.completed_at | date }}
        </template>
      </el-table-column>
      <el-table-column
          prop="count"
          label="Mennyiség"
          width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.count }}  {{ scope.row.pack_type_name }}
        </template>
      </el-table-column>
      <el-table-column
          prop="unit_price"
          label="Egységár"
          width="160"
      >
        <template slot-scope="scope">
          <div class="" style="display: flex; justify-content: space-between">
            {{ scope.row.unit_price | currency }}

            <el-tag
              type="warning"
              size="small"
              v-if="!scope.row.is_stockist"
            >
              Becsült ár
            </el-tag>
          </div>

        </template>
      </el-table-column>
      <el-table-column
          prop="net_price"
          label="Nettó ár"
          width="150"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.net_price | currency }}
        </template>
      </el-table-column>
      <el-table-column
          prop="creator_user_name"
          label="Rögzítő"
          width="150"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.creator_user_name }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

  export default {
    components: {
    },

    props: ['stockDifference', 'loading'],

    data() {
      return {
        currentSort: {
          prop: 'gross_price',
          order: 'desc',
        },
      };
    },
    computed: {
      plusStock() {
        let sum = 0;

        this.stockDifference.forEach((item) => {
          if (item.net_price > 0 ) {
            sum += item.net_price;
          }
        })

        return sum;
      },

      minusStock() {
        let sum = 0;

        this.stockDifference.forEach((item) => {
          if (item.net_price < 0 ) {
            sum += item.net_price;
          }
        })

        return sum;
      },

      isEstimated() {
        let estimated = false;
        this.stockDifference.forEach((item) => {
          if (!item.is_stockist) {
            estimated = true;
          }
        })

        return estimated;
      }
    },
    async mounted() {

    },
    methods: {

    },
  };
</script>
<style lang="scss">
  .productHistory-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
